// src/pages/ClientPanel/Products/filterproduct/ProductsFilterModal.tsx

import React, { useState, useEffect } from 'react';

// Importamos TUDO do seu filterstyle.ts
import {
  FilterDropdownContainer,
  DropdownCloseButton,
  FilterSelect,
  ApplyFilterButton,
} from './filterstyle';

// Caminho para o ícone de fechar
import CloseIcon from '../../../../assets/produtcss/close.svg';

// --- DEFINIÇÃO DE TIPOS ---
export type FilterStatus = 'all' | 'active' | 'inactive';

interface ProductsFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApplyFilter: (status: FilterStatus) => void;
  currentFilterStatus?: FilterStatus;
  top: number;
  left: number;
  width: number;
}

const ProductsFilterModal: React.FC<ProductsFilterModalProps> = ({
  isOpen,
  onClose,
  onApplyFilter,
  currentFilterStatus = 'all',
  top,
  left,
  width,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<FilterStatus>(currentFilterStatus);

  useEffect(() => {
    setSelectedStatus(currentFilterStatus);
  }, [currentFilterStatus]);

  if (!isOpen) return null;

  const handleApply = () => {
    onApplyFilter(selectedStatus);
    onClose();
  };

  return (
    <FilterDropdownContainer $top={top} $left={left} $width={width}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h2>Filtrar</h2>
        <DropdownCloseButton onClick={onClose}>
          <img src={CloseIcon} alt="Fechar" />
        </DropdownCloseButton>
      </div>

      <FilterSelect
        value={selectedStatus}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setSelectedStatus(e.target.value as FilterStatus)}
      >
        <option value="all">Filtrar por: Todos</option>
        <option value="active">Filtrar por: Positivo</option>
        <option value="inactive">Filtrar por: Inativo</option>
      </FilterSelect>

      <ApplyFilterButton onClick={handleApply}>
        Aplicar filtro
      </ApplyFilterButton>
    </FilterDropdownContainer>
  );
};

export default ProductsFilterModal;